module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"campaigns":"Aktionen","end":"Ende","period":"Zeitraum","search":"Suche","start":"Start","state":"Status","title":"Titel","withOrders":"mit Bestellungen"},"en":{"campaigns":"Campaigns","end":"End","manufacturer":"Manufacturer","period":"Period","search":"Search","start":"Start","state":"State","title":"Title","withOrders":"with orders"}}')
  delete Component.options._Ctor
}
